import React from 'react'
// import TrashIcon from '../../elements/icons/TrashIcon'
import InvoiceStatus from '../../elements/InvoiceStatus'
import CameraIcon from '../../elements/icons/CameraIcon'
import moment from 'moment'

const InvoiceAssignmentCard = ({assignment}) => {
  return (
    <div className='w-full p-[15px] rounded-[8px] border border-dashed bg-white border-gray-300 flex items-start justify-between gap-x-[10px]'>
        <div className='w-[70px]'>
            <div className='bg-gray-50 h-[50px] w-[50px] rounded-[8px] flex items-center justify-center' style={{
            backgroundImage: `url(" ${assignment.student.passportPhotograph} ")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'none'
            }}>
                {(!assignment.student.passportPhotograph || assignment.student.passportPhotograph === '') &&
                    <CameraIcon className={`w-8 h-8 text-gray-400`} />
                }
            </div>
        </div>
        <div className='w-full flex items-center justify-between gap-x-[10px]'>
            <div>
                <h4 className='font-[500] text-sm'>{assignment.student.fullName} - {assignment.studentClass}</h4>
                <p className='font-space-grotesk text-xs'>{assignment.student.admissionNumber}</p>
                <p className='text-xs'>Deadline: {moment(assignment.paymentDeadline).format('LL')}</p>
            </div>
            <InvoiceStatus status={assignment.status} />
            {/* <div className="w-full flex items-center justify-between mt-3 flex-row-reverse">
                <button onClick={()=>{openFee()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Fee <ArrowIcon className={`w-5 h-5`} /></button> 

                <button className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                    <TrashIcon className={`w-4 h-4`} />
                </button>

                <InvoiceStatus status={assignment.status} />
            </div> */}
        </div>
    
    </div>
  )
}

export default InvoiceAssignmentCard